// extracted by mini-css-extract-plugin
export default {"img":"LpBanner_img__el753","container":"LpBanner_container__RHA4t"};